import { Asset, AssetsInfo } from '@interfaces'

export const mapAssetInfoToAsset = (data: AssetsInfo): Asset => {
  return {
    id: data?.id,
    ticker: data?.ticker,
    name: data?.name,
    isin: data?.isin,
    market: data?.market,
    type: data?.type,
    price: data?.price,
    lastClosed: data?.lastClosed,
    logoUrl: data?.logoUrl,
    performance: data?.performance,
    risk: data?.risk,
    investmentInfo: data?.investmentInfo,
  }
}
